<template>
  <div
    class="dn-placeholder"
    :data-id="fields?.id"
  >
    <client-only>
      <dn-component
        :type="type"
        :data="{ ...useKeyConversion().convertKeys(fields), slots }"
      />
    </client-only>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  fields: {
    type: Object,
    required: false,
    default: () => {}
  },
  slots: {
    type: Array,
    required: false,
    default: () => []
  }
});

const { showEditionContent } = useRuntimeConfig().public;

provide('lazy', true);
provide('show_opinion_kicker', true);
provide('embed_edition_content', showEditionContent !== false);
provide('strip_title_br', true);

const type = computed(() => {
  const mapping: { [key: string]: string } = {
    'cpp-streams': 'editionKilkayaCollection',
    'cpp-collections': 'editionCommonCollection',
    'cpp-categories': 'editionCommonCollection',
    'cpp-mostread': 'mostReadCollection',
    'cpp-editortoplist': 'editorToplistCollection',
    'cpp-embed': 'embed',
    'cpp-sections': 'editionSectionCollection',
    'cpp-ads': 'customAds',
    'cpp-latestnews': 'editionCommonCollection',
    'cpp-dataplatform': 'segmentCollection'
  };
  const typeKey = (props.fields.type as string).split('-').slice(0, 2).join('-') || '';
  return mapping[typeKey] || (props.fields?.type as string);
});
</script>
<style lang="scss">
.dn-placeholder {
  &.highlighted {
    border-radius: var(--border-radius-teaser-max);
    outline: 4px solid #7d7df7;
  }
}
</style>
